export default function () {
  const blacklistSessionStart = [
    // Logout: Why? Because we don't want to create pending
    //         fetches that will recreate the cookie on success
    //         while we are trying to delete the session.
    'logout',
    'liveslide_security',
    'modal'
  ]

  const url = new URL(window.location.href)
  const route = url.pathname.substr(1) || url.hash.substr(1)
  return blacklistSessionStart.includes(route) === false
}
